module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-default margin-bottom-0px"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('div', {
    staticClass: "action-button pull-right"
  }, [_c('div', {
    staticClass: "form-group col-xs-12 col-sm-3",
    staticStyle: {
      "flex-wrap": "nowrap !important"
    }
  }, [_c('label', {
    attrs: {
      "for": "date-from"
    }
  }, [_vm._v("Start Date")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fromDt),
      expression: "fromDt"
    }],
    staticClass: "form-control",
    attrs: {
      "max": _vm.toDt,
      "type": "date",
      "id": "date-from",
      "placeholder": "From"
    },
    domProps: {
      "value": (_vm.fromDt)
    },
    on: {
      "keyup": _vm.searchReengagementWithSelectedCriteria,
      "change": _vm.searchReengagementWithSelectedCriteria,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fromDt = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "id": "basic-addon2"
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        return _vm.clearDate('fromDt')
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12 col-sm-3"
  }, [_c('label', {
    attrs: {
      "for": "date-to"
    }
  }, [_vm._v("End Date")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.toDt),
      expression: "toDt"
    }],
    staticClass: "form-control",
    attrs: {
      "min": _vm.fromDt,
      "type": "date",
      "id": "date-to",
      "placeholder": "To"
    },
    domProps: {
      "value": (_vm.toDt)
    },
    on: {
      "keyup": _vm.searchReengagementWithSelectedCriteria,
      "change": _vm.searchReengagementWithSelectedCriteria,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.toDt = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "id": "basic-addon2"
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        return _vm.clearDate('toDt')
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12 col-sm-6 search-reengagement"
  }, [_c('label', {
    attrs: {
      "for": "date-to"
    }
  }, [_vm._v("Search")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchReengagement),
      expression: "searchReengagement"
    }, {
      name: "reset-input",
      rawName: "v-reset-input"
    }],
    staticClass: "search-box-reset form-control mrgn-right-20px searchBox",
    attrs: {
      "type": "text",
      "placeholder": "Type here to search and press 'Enter'"
    },
    domProps: {
      "value": (_vm.searchReengagement)
    },
    on: {
      "keyup": _vm.searchReengagementWithSelectedCriteria,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchReengagement = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12 col-sm-6 create-reengagement"
  }, [_c('label', {
    attrs: {
      "for": "date-to"
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": "/reengagement-manager/create"
    }
  }, [_vm._v("Create Reengagement")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "role": "tabpanel",
      "id": "scheduled"
    }
  }, [_c('table', {
    staticClass: "table table-striped table-apps"
  }, [_c('thead', {
    staticClass: "thead-dark"
  }, [_c('th', {
    staticClass: "padding-left5px"
  }, [_vm._v("Reengagement Name "), _c('i', {
    staticClass: "fa fa-long-arrow-up",
    on: {
      "click": function($event) {
        return _vm.sortReengagement('campaign_name', 'asc', 'scheduled')
      }
    }
  }), _c('i', {
    staticClass: "fa fa-long-arrow-down",
    on: {
      "click": function($event) {
        return _vm.sortReengagement('campaign_name', 'desc', 'scheduled')
      }
    }
  })]), _vm._v(" "), _c('th', {
    staticClass: "align-center"
  }, [_vm._v("Created On (UTC)")]), _vm._v(" "), _c('th', {
    staticClass: "align-center"
  }, [_vm._v("Country")]), _vm._v(" "), _c('th', {
    staticClass: "align-center"
  }, [_vm._v("Scheduled On")]), _vm._v(" "), _c('th', {
    staticClass: "align-center"
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    staticClass: "align-center"
  }), _vm._v(" "), _c('th', {
    staticClass: "align-center"
  }, [_vm._v("Clone/Copy ")]), _vm._v(" "), _c('th', {
    staticClass: "align-center"
  }, [_vm._v("Report")]), _vm._v(" "), _c('th', {
    staticClass: "align-center"
  }, [_vm._v("Edit")]), _vm._v(" "), _c('th', {
    staticClass: "align-center"
  }, [_vm._v("Delete")])]), _vm._v(" "), _c('tbody', [(_vm.scheduledreengagementList.length === 0 && !_vm.loading) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "10",
      "align": "center"
    }
  }, [_vm._v("No Result found.")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.scheduledreengagementList), function(reengagement, index) {
    return _c('tr', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.scheduledreengagementList.length),
        expression: "scheduledreengagementList.length"
      }],
      key: index
    }, [_c('td', [_vm._v(_vm._s(reengagement.campaign_name))]), _vm._v(" "), _c('td', {
      staticClass: "align-center"
    }, [_vm._v(_vm._s(_vm.formatDate(reengagement.createdAt, 'd/M/Y hh:ss', true)))]), _vm._v(" "), _c('td', {
      staticClass: "align-center"
    }, [_vm._v(_vm._s(reengagement.country_name))]), _vm._v(" "), _c('td', {
      staticClass: "align-center"
    }, [_vm._v(_vm._s(_vm.formatDate(reengagement.local_time, 'd/M/Y hh:ss')))]), _vm._v(" "), _c('td', {
      staticClass: "align-center"
    }, [_vm._v(_vm._s(reengagement.status))]), _vm._v(" "), _c('td', {
      staticClass: "align-center"
    }, [(reengagement.group_list && reengagement.group_list.length) ? _c('input', {
      staticClass: "btn btn-primary btn-sm center",
      attrs: {
        "type": "button",
        "value": "Send Test"
      },
      on: {
        "click": function($event) {
          return _vm.testNudgeClick(reengagement)
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "align-center"
    }, [_c('input', {
      staticClass: "btn btn-primary btn-sm center",
      attrs: {
        "type": "button",
        "value": "Copy"
      },
      on: {
        "click": function($event) {
          return _vm.openCopyModal(reengagement)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "align-center"
    }, [(reengagement.audience_id) ? _c('i', {
      staticClass: "fa fa-bar-chart",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          return _vm.getReengagementReport(reengagement, _vm.reengagementStatus.Scheduled)
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "align-center"
    }, [_c('router-link', {
      attrs: {
        "to": ("/reengagement-manager/" + (reengagement.id))
      }
    }, [_c('i', {
      staticClass: "fa fa-edit",
      attrs: {
        "aria-hidden": "true"
      }
    })])], 1), _vm._v(" "), _c('td', {
      staticClass: "align-center"
    }, [(reengagement.status === 'Draft') ? _c('i', {
      staticClass: "fa fa-times-circle link-action-color",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          return _vm.openDeleteModal(reengagement.id)
        }
      }
    }) : _vm._e()])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "pagination-container"
  }, [(_vm.schedulePageCount > 0) ? _c('paginate', {
    attrs: {
      "page-count": _vm.schedulePageCount,
      "click-handler": _vm.getDataForSchedulePage,
      "prev-text": 'Prev',
      "next-text": 'Next',
      "container-class": 'pagination'
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "role": "tabpanel",
      "id": "deployed"
    }
  }, [_c('table', {
    staticClass: "table table-striped table-apps"
  }, [_c('thead', {
    staticClass: "thead-dark"
  }, [_c('th', {
    staticClass: "padding-left5px"
  }, [_vm._v("Reengagement Name "), _c('i', {
    staticClass: "fa fa-long-arrow-up",
    on: {
      "click": function($event) {
        return _vm.sortReengagement('campaign_name', 'asc', 'deployed')
      }
    }
  }), _c('i', {
    staticClass: "fa fa-long-arrow-down",
    on: {
      "click": function($event) {
        return _vm.sortReengagement('campaign_name', 'desc', 'deployed')
      }
    }
  })]), _vm._v(" "), _c('th', {
    staticClass: "align-center"
  }, [_vm._v("Created On (UTC)")]), _vm._v(" "), _c('th', {
    staticClass: "align-center"
  }, [_vm._v("Country")]), _vm._v(" "), _c('th', {
    staticClass: "align-center"
  }, [_vm._v("Scheduled On")]), _vm._v(" "), _c('th', {
    staticClass: "align-center"
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    staticClass: "align-center"
  }, [_vm._v("Clone/Copy ")]), _vm._v(" "), _c('th', {
    staticClass: "align-center"
  }, [_vm._v("Report")])]), _vm._v(" "), _c('tbody', [(_vm.deployedreengagementList.length === 0 && !_vm.loading) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "10",
      "align": "center"
    }
  }, [_vm._v("No Result found.")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.deployedreengagementList), function(reengagement, index) {
    return _c('tr', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.deployedreengagementList.length),
        expression: "deployedreengagementList.length"
      }],
      key: index
    }, [_c('td', [_vm._v(_vm._s(reengagement.campaign_name))]), _vm._v(" "), _c('td', {
      staticClass: "align-center"
    }, [_vm._v(_vm._s(_vm.formatDate(reengagement.createdAt, 'd/M/Y hh:ss', true)))]), _vm._v(" "), _c('td', {
      staticClass: "align-center"
    }, [_vm._v(_vm._s(reengagement.country_name))]), _vm._v(" "), _c('td', {
      staticClass: "align-center"
    }, [_vm._v(_vm._s(_vm.formatDate(reengagement.local_time, 'd/M/Y hh:ss')))]), _vm._v(" "), _c('td', {
      staticClass: "align-center"
    }, [_vm._v(_vm._s(reengagement.status))]), _vm._v(" "), _c('td', {
      staticClass: "align-center"
    }, [_c('input', {
      staticClass: "btn btn-primary btn-sm center",
      attrs: {
        "type": "button",
        "value": "Copy"
      },
      on: {
        "click": function($event) {
          return _vm.openCopyModal(reengagement)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "align-center"
    }, [_c('i', {
      staticClass: "fa fa-bar-chart",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          return _vm.getReengagementReport(reengagement, _vm.reengagementStatus.Deployed)
        }
      }
    })])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "pagination-container"
  }, [(_vm.deployPageCount > 0) ? _c('paginate', {
    attrs: {
      "page-count": _vm.deployPageCount,
      "click-handler": _vm.getDataForDeployPage,
      "prev-text": 'Prev',
      "next-text": 'Next',
      "container-class": 'pagination'
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "role": "tabpanel",
      "id": "failed"
    }
  }, [_c('table', {
    staticClass: "table table-striped table-apps"
  }, [_c('thead', {
    staticClass: "thead-dark"
  }, [_c('th', {
    staticClass: "padding-left5px"
  }, [_vm._v("Reengagement Name "), _c('i', {
    staticClass: "fa fa-long-arrow-up",
    on: {
      "click": function($event) {
        return _vm.sortReengagement('campaign_name', 'asc', 'deployed')
      }
    }
  }), _c('i', {
    staticClass: "fa fa-long-arrow-down",
    on: {
      "click": function($event) {
        return _vm.sortReengagement('campaign_name', 'desc', 'deployed')
      }
    }
  })]), _vm._v(" "), _c('th', {
    staticClass: "align-center"
  }, [_vm._v("Created On (UTC)")]), _vm._v(" "), _c('th', {
    staticClass: "align-center"
  }, [_vm._v("Country")]), _vm._v(" "), _c('th', {
    staticClass: "align-center"
  }, [_vm._v("Scheduled On")]), _vm._v(" "), _c('th', {
    staticClass: "align-center"
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    staticClass: "align-center"
  }, [_vm._v("Clone/Copy ")]), _vm._v(" "), _c('th', {
    staticClass: "align-center"
  }, [_vm._v("Details")])]), _vm._v(" "), _c('tbody', [(_vm.failedreengagementList.length === 0 && !_vm.loading) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "10",
      "align": "center"
    }
  }, [_vm._v("No Result found.")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.failedreengagementList), function(reengagement, index) {
    return _c('tr', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.failedreengagementList.length),
        expression: "failedreengagementList.length"
      }],
      key: index
    }, [_c('td', [_vm._v(_vm._s(reengagement.campaign_name))]), _vm._v(" "), _c('td', {
      staticClass: "align-center"
    }, [_vm._v(_vm._s(_vm.formatDate(reengagement.createdAt, 'd/M/Y hh:ss', true)))]), _vm._v(" "), _c('td', {
      staticClass: "align-center"
    }, [_vm._v(_vm._s(reengagement.country_name))]), _vm._v(" "), _c('td', {
      staticClass: "align-center"
    }, [_vm._v(_vm._s(_vm.formatDate(reengagement.local_time, 'd/M/Y hh:ss')))]), _vm._v(" "), _c('td', {
      staticClass: "align-center"
    }, [_vm._v(_vm._s(reengagement.status))]), _vm._v(" "), _c('td', {
      staticClass: "align-center"
    }, [_c('input', {
      staticClass: "btn btn-primary btn-sm center",
      attrs: {
        "type": "button",
        "value": "Copy"
      },
      on: {
        "click": function($event) {
          return _vm.openCopyModal(reengagement)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "align-center"
    }, [_c('i', {
      staticClass: "fa fa-bar-chart",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          return _vm.getReengagementReport(reengagement, _vm.reengagementStatus.Failed)
        }
      }
    })])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "pagination-container"
  }, [(_vm.failePageCount > 0) ? _c('paginate', {
    attrs: {
      "page-count": _vm.failePageCount,
      "click-handler": _vm.getDataForFailPage,
      "prev-text": 'Prev',
      "next-text": 'Next',
      "container-class": 'pagination'
    }
  }) : _vm._e()], 1)])])])])])])]), _vm._v(" "), (_vm.showDeployedReportModal) ? _c('deployedReportModal', {
    attrs: {
      "reengagementReport": _vm.deployedReport,
      "campaignDetails": _vm.campaignDetails
    },
    on: {
      "close": function($event) {
        return _vm.closeReport(_vm.reengagementStatus.Deployed)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showScheduledReportModal) ? _c('scheduledReportModal', {
    attrs: {
      "reengagementReport": _vm.scheduledReport,
      "campaignDetails": _vm.campaignDetails
    },
    on: {
      "close": function($event) {
        return _vm.closeReport(_vm.reengagementStatus.Scheduled)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showFailedReportModal) ? _c('failedReportModal', {
    attrs: {
      "reengagementReport": _vm.failureReport,
      "campaignDetails": _vm.campaignDetails
    },
    on: {
      "close": function($event) {
        return _vm.closeReport(_vm.reengagementStatus.Failed)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('form', {
    attrs: {
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.sendTestNudge.apply(null, arguments)
      }
    }
  }, [(_vm.audienceSelectionVisible) ? _c('div', {
    staticClass: "modal-backdrop",
    attrs: {
      "id": "userSelection"
    }
  }, [_c('div', {
    staticClass: "modal modal-md modal-user-selection"
  }, [_c('div', {
    staticClass: "test-nudge-container"
  }, [_vm._t("body", function() {
    return [_c('div', {
      staticClass: "form-horizontal"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "form-group col-xs-12 col-sm-12 col-md-12"
    }, [_c('label', {
      staticClass: "control-label modal-label",
      attrs: {
        "for": "search"
      }
    }, [_vm._v("Select Group:")]), _vm._v("\n                    \n                  "), _c('div', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v("Note: You can only select groups with Nudge and (Conversation or Keyword)")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "flex",
        "flex-flow": "wrap"
      }
    }, _vm._l((_vm.selectedReengagement.group_list), function(group) {
      return _c('div', {
        key: group.group_name,
        staticStyle: {
          "width": "233px"
        }
      }, [_c('label', {
        staticClass: "radio-inline campaign-group-details",
        class: {
          'reengagement-group-disabled': !((group.keyword_id || group.conversation_id) && group.msg_template_id)
        },
        staticStyle: {
          "display": "flex",
          "flex-direction": "column",
          "margin-bottom": "10px",
          "padding-left": "20px"
        }
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.selectedGroup),
          expression: "selectedGroup"
        }],
        attrs: {
          "type": "radio",
          "disabled": !((group.keyword_id || group.conversation_id) && group.msg_template_id)
        },
        domProps: {
          "value": group,
          "checked": _vm._q(_vm.selectedGroup, group)
        },
        on: {
          "change": function($event) {
            _vm.selectedGroup = group
          }
        }
      }), _vm._v(" "), _c('div', [_vm._v(_vm._s(group.group_name))]), _vm._v(" "), _c('div', [_vm._v("Nudge: "), _c('span', {
        staticClass: "campaign-details-text"
      }, [_vm._v(_vm._s(group.msg_template_name ? group.msg_template_name : '-'))])]), _vm._v(" "), (group.conversation) ? _c('div', [_vm._v("Conversation: "), _c('span', {
        staticClass: "campaign-details-text"
      }, [_vm._v(_vm._s(group.conversation ? group.conversation : '-'))])]) : _c('div', [_vm._v("Keyword: "), _c('span', {
        staticClass: "campaign-details-text"
      }, [_vm._v(_vm._s(group.keyword ? group.keyword : '-'))])]), _vm._v(" "), _c('div', [_vm._v("Destination: "), _c('span', {
        staticClass: "campaign-details-text"
      }, [_vm._v(_vm._s(group.destination_app_name ? group.destination_app_name : '-'))])]), _vm._v(" "), _c('div', [_vm._v("Split Percent: "), _c('span', {
        staticClass: "campaign-details-text"
      }, [_vm._v(_vm._s(group.split_percent || group.split_percent === 0 ? group.split_percent + '%' : '-'))])])])])
    }), 0), _vm._v(" "), (_vm.submittedTestNudge && !_vm.$v.selectedGroup.required) ? _c('span', {
      staticClass: "text-red pull-right",
      staticStyle: {
        "margin-right": "20px"
      }
    }, [_vm._v("Please select a group.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "form-group col-xs-12 col-sm-12 col-md-12"
    }, [_c('label', {
      staticClass: "control-label modal-label",
      attrs: {
        "for": "search"
      }
    }, [_vm._v("Select test user(s):")]), _vm._v(" "), _c('label', {
      staticClass: "hint-text"
    }, [_vm._v("Only onboarded users appear here. To include your account in a test, make sure you're currently onboarded to the correct country.")]), _vm._v("\n                    \n                  "), _c('div', {
      staticClass: "users-checkbox-container"
    }, [_vm._l((_vm.userList), function(user) {
      return _c('div', {
        key: user.account_id
      }, [_c('label', {
        staticClass: "checkbox-inline col-xs-6 col-sm-6 col-md-5 col-lg-4"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.selectedUsers),
          expression: "selectedUsers"
        }],
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "value": user,
          "checked": Array.isArray(_vm.selectedUsers) ? _vm._i(_vm.selectedUsers, user) > -1 : (_vm.selectedUsers)
        },
        on: {
          "change": function($event) {
            var $$a = _vm.selectedUsers,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = user,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.selectedUsers = $$a.concat([$$v]))
              } else {
                $$i > -1 && (_vm.selectedUsers = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
              }
            } else {
              _vm.selectedUsers = $$c
            }
          }
        }
      }), _vm._v(_vm._s(user.account_name) + "\n                      ")])])
    }), _vm._v(" "), (!_vm.userList.length) ? _c('div', [_vm._v("There are no users ")]) : _vm._e()], 2), _vm._v(" "), (_vm.submittedTestNudge && !_vm.$v.selectedUsers.required) ? _c('span', {
      staticClass: "text-red pull-right",
      staticStyle: {
        "margin-right": "20px"
      }
    }, [_vm._v("Please select users to send message.")]) : _vm._e()])])])]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    staticStyle: {
      "margin-top": "auto",
      "padding": "0px"
    }
  }, [_c('div', {
    staticClass: "form-group pull-right"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeAudienceSelection
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Send Test")])])])])])]) : _vm._e()]), _vm._v(" "), (_vm.isDeleteConfirmationVisible) ? _c('reengagementDeleteModal', {
    attrs: {
      "isDeleteConfirmationVisible": _vm.isDeleteConfirmationVisible,
      "confirmationMessage": "Are you sure you want to delete this Reengagement ?",
      "actionToBePerformed": "Delete Reengagement"
    },
    on: {
      "close": _vm.closeConfirmationModal,
      "deleteReengagement": _vm.deleteReengagement
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showCopyReengagementModal) ? _c('copyReengagementModal', {
    attrs: {
      "showCopyReengagementModal": _vm.showCopyReengagementModal,
      "currentName": _vm.currentName,
      "restoredValues": _vm.restoredValues
    },
    on: {
      "close": _vm.closeCopyModal,
      "copyReengagement": _vm.copyReengagement
    }
  }) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('BlockUI', [_c('i', {
    staticClass: "fa fa-cog fa-spin fa-3x fa-fw"
  }), _c('br'), _vm._v("Please wait...")]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("\n      Reengagement Manager\n    ")]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-dashboard"
  }), _vm._v(" Home")])]), _vm._v(" "), _c('li', [_vm._v("Reengagement Manager")]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Reengagement List")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav nav-tabs",
    attrs: {
      "role": "tablist"
    }
  }, [_c('li', {
    staticClass: "active",
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": "#scheduled",
      "aria-controls": "scheduled",
      "role": "tab",
      "data-toggle": "tab"
    }
  }, [_vm._v("Scheduled Reengagements")])]), _vm._v(" "), _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": "#deployed",
      "aria-controls": "deployed",
      "role": "tab",
      "data-toggle": "tab"
    }
  }, [_vm._v("Deployed Reengagements")])]), _vm._v(" "), _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": "#failed",
      "aria-controls": "failed",
      "role": "tab",
      "data-toggle": "tab"
    }
  }, [_vm._v("Failed Reengagements")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-770493f6","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reengagement-manager/reengagementList.vue
// module id = Qd1c
// module chunks = 1